import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { EInvoiceRecord, EInvoiceRecordCreate, EInvoiceRecordFilter } from '../data/eInvoiceRecord';

export function createEInvoiceRecordService(client: AxiosInstance) {
  return createCrudService<EInvoiceRecord, EInvoiceRecordCreate, EInvoiceRecordFilter>(
    client,
    '/accounting/EInvoiceRecord',
    'id',
  );
}

export type EInvoiceRecordService = CrudService<EInvoiceRecord, EInvoiceRecordCreate, EInvoiceRecordFilter>;
